import types from './types';

const emptyArray = [];

const initialState = {
  stations: emptyArray,
  isFetching: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    case types.SET_STATIONS:
      return {
        ...state,
        stations: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
